module.exports = __webpack_public_path__ + "static/media/IconEye.36f38876.svg";